export const BLUE = "#1565c0";
export const LIGHT_GREY = "#f5f5f5";
export const WHITE = "#fff";